<template>
    <v-card>
        <v-card-text>
            <v-layout row wrap>
                <v-flex :class="{ 'xs4 md2': !floating, xs4: floating }">
                    <v-img
                        v-if="item.product && productImage"
                        :src="productImage.small"
                        :lazy-src="productImage.placeholder"
                        :alt="productImage.image_description"
                        :aspect-ratio="1 / 1"
                    />
                </v-flex>
                <v-flex :class="{ 'xs8 md10': !floating, xs8: floating }">
                    <v-layout row wrap>
                        <v-flex :class="{ 'xs8 md12': !floating, xs8: floating }">
                          <router-link
                              :to="
                                    $product.getProductRouteConfig(
                                        item.product_id === item.catalog_item_id
                                            ? item.product
                                            : { id: item.catalog_item_id },
                                    )
                                "
                              class="subheading"
                              v-if="$basket.isNotBuyableItem(item) === false"
                          >
                                {{ $basket.getItemTitle(item) }}
                            </router-link>
                            <template v-else>
                                <span class="subheading">{{ $basket.getItemTitle(item) }}</span>
                            </template>
                        </v-flex>
                        <v-flex
                            v-if="!noControls"
                            :class="{ 'xs4 hidden-md-and-up text-xs-right': !floating, 'xs4 text-xs-right': floating }"
                        >
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon v-on="on" @click="$basket.removeBasketItem(item)" class="ma-0">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ 'Remove product' | translation }}</span>
                            </v-tooltip>
                        </v-flex>
                        <v-flex
                            xs12
                            v-if="!noControls && $basket.isNotBuyableItem(item) === false"
                            class="text-xs-right"
                        >
                            <amount-input
                                class="d-inline-block amount-input"
                                :value.sync="itemQuantity"
                                :product="item.product"
                                :current-merchant-id="item.options.merchant"
                                :current-product-id="item.catalog_item_id"
                                :key="`${item.catalog_item_id}-${item.options.merchant}`"
                                is-basket-field
                            ></amount-input>
                        </v-flex>

                        <v-flex xs12 v-else>
                            <span>{{ 'number' | translation }} </span>
                            {{ itemQuantity }}
                        </v-flex>

                        <v-flex xs12 v-if="!noControls">
                            <div class="caption" v-for="buyOption in item.buyOptions" :key="buyOption.name">
                                <span v-for="(value, key, index) in buyOption.Values" :key="key">
                                    <span class="font-weight-bold">{{ value.name | translation }}: </span>
                                    <a v-if="value.value.indexOf('http') === 0" :href="value.value" target="_blank">
                                        {{ 'engraving_image' | translation }}
                                    </a>
                                    <span v-else>
                                        {{ value.value }}
                                    </span>
                                    <span v-if="index !== Object.keys(buyOption.Values).length - 1"> / </span>
                                </span>
                            </div>
                        </v-flex>

                        <v-flex class="xs12 text-xs-right pb-0">
                            <span>{{ 'price_excl_vat' | translation }} </span>
                            <span>{{ $grillshop.getBasketItemTotalPriceExclVat(item) | currency }}</span
                            ><br />
                            <span>{{ 'price' | translation }} </span>
                            <del v-if="isPriceWithDiscount(item)" class="org-preis">
                                <span>{{ $basket.getPriceData(item).original_price_inkl_vat | currency }}</span>
                            </del>
                            <span>{{ $basket.getPriceData(item).price | currency }}</span
                            ><br />
                            <span v-if="isPriceWithDiscount(item)" class="success--text">
                                {{ 'saving' | translation }}
                                <span>
                                    {{
                                        ($basket.getPriceData(item).original_price_inkl_vat -
                                            $basket.getPriceData(item).price)
                                            | currency
                                    }}
                                </span>
                            </span>
                        </v-flex>
                        <v-flex
                            v-if="!noControls"
                            :class="{ 'md6 hidden-sm-and-down pt-0': !floating, 'd-none': floating }"
                        >
                            <v-btn @click="$basket.removeBasketItem(item)" flat small class="ma-0">
                                {{ 'Remove product' | translation }} <v-icon>delete</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex
                            :class="{
                                'xs12 md6 text-xs-right': !floating && !noControls,
                                'xs12 text-xs-right': floating || noControls,
                            }"
                        >
                            <span>{{ 'total' | translation }} </span>
                            <span>{{ $basket.getBasketItemTotalPrice(item) | currency }}</span>
                        </v-flex>

                        <v-flex v-if="!noControls && selfPickup" class="xs12">
                            <v-checkbox
                                :disabled="!$basket.isItemPickupable(item, merchantId)"
                                hide-details
                                v-model="item.pickup"
                                @change="setItemPickup(item)"
                                label="Artikel selbst abholen"
                                class="justify-end"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
import AmountInput from '@breakmedia/prime-vue-product/src/product-page/AmountInput';

export default {
    name: 'BasketItem',
    components: {
        AmountInput,
    },
    data() {
        return {
            itemQuantity: 1,
        };
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        floating: {
            type: Boolean,
            default: false,
        },
        noControls: {
            type: Boolean,
            default: false,
        },
        selfPickup: {
            type: Boolean,
            default: false,
        },
        quantity: {
            type: Number,
        },
    },
    created() {
        if (!this.item.hasOwnProperty('product')) {
            this.item.product = this.$basket.getBasketItemProduct(this.item);
        }
    },
    computed: {
        productImage() {
            let image;

            if (this.item.catalog_item_id !== this.item.product_id && this.item.product.images.product_images.length) {
                for (let productImage of this.item.product.images.product_images) {
                    if (productImage.products.includes(this.item.catalog_item_id)) {
                        image = productImage;
                    }
                }
            }

            if (!image) {
                image = this.item.product.images.default;
            }

            return image;
        },
    },
    methods: {
        getBuyOptionValuesString(buyOptionValues) {
            let result = [];

            for (let value of Object.values(buyOptionValues)) {
                if (value.value) {
                    result.push(
                        '<span className="font-weight-bold">' +
                            this.$language.translate(value.name) +
                            '</span>' +
                            ': ' +
                            this.$language.translate(value.value),
                    );
                }
            }

            return result.join(' / ');
        },
        isPriceWithDiscount(item) {
            const priceData = this.$basket.getPriceData(item);
            if (priceData) {
                return priceData.original_price_inkl_vat > priceData.price;
            }
        },
    },
    watch: {
        itemQuantity(val) {
            if (this.item.quantity !== val) {
                this.item.quantity = val;
                this.$basket.updateBasketItem(this.item);
            }
        },
        quantity: {
            immediate: true,
            handler(val) {
                this.itemQuantity = val;
            },
        },
    },
};
</script>
